import type { Ref } from 'vue'
import { fetchBannerMatchList } from '../match'
import type { IBannerMatchListResult } from '../types/bannerMatchList'
import type { IMatchListRecord } from '../types/match'
import { formatDataObj } from './useMatchList'
import { ResultEnum } from '@/enums/httpEnum'
import { useMatchScore } from '@/hooks/useScore'
import router from '@/router'

export interface IUseBannerConfig {
  /** 自动请求接口 */
  autoFetch: true
}

export interface IUseBannerResultFormat extends IBannerMatchListResult {
  nsg: IMatchListRecord['nsg']
  ts: IMatchListRecord['ts']
  mc: IMatchListRecord['mc']
  lg: IMatchListRecord['lg']
  tsFormat: IMatchListRecord['tsFormat']
}

export interface IUseBannerResult {
  banner: Ref<Pick<IBannerMatchListResult, 'bty' | 'img' | 'desc'>[]>
  list: Ref<Omit<IMatchListRecord, 'img'>[]>
  getList: () => void
  refresh: () => void
  clearBannerInterval: () => void
  reset: () => void
}

// 全局数据
const banner = ref()
const list = ref()

let bannerInter = null

/** 获取banner */
export function useBanner(config?: IUseBannerConfig): IUseBannerResult {
  const { autoFetch } = config || {}

  function getList() {
    // fetchBannerMatchList({
    //   platform: 3,
    // }).then((res) => {
    //   banner.value = res.filter(e => Number(e.bty) === 1).slice(0, 3)
    //   // if (router.currentRoute.value.path === '/index') {
    //   list.value = res.filter(e => Number(e.bty) === 3).map((e) => {
    //     const result = {} as IMatchListRecord
    //     Object.assign(result, e)
    //     result.nsg = e.sgs
    //     result.ts = e.tms
    //     result.mc = e.clk
    //     result.lg = {
    //       id: e.lid,
    //       na: e.lnm,
    //       sid: e.sid,
    //     }
    //     result.id = e.mid
    //     const formatData = formatDataObj(result)
    //     const { list } = useMatchScore(result)
    //     return {
    //       ...formatData,
    //       tsFormat: list,
    //     }
    //   })
    //   // }
    // }).catch((err) => {
    //   if (err?.code === ResultEnum.LOGINEXP) {
    //     clearBannerInterval()
    //   }
    // })
  }

  function refresh() {
    bannerInter && clearInterval(bannerInter)
    bannerInter = setInterval(() => {
      getList()
    }, 4000)
    getList()
  }

  function clearBannerInterval() {
    bannerInter && clearInterval(bannerInter)
  }

  function reset() {
    banner.value = null
    list.value = null
    clearBannerInterval()
  }

  if (autoFetch) refresh()

  return {
    list,
    banner,
    getList,
    refresh,
    clearBannerInterval,
    reset,
  }
}
